import md5 from "blueimp-md5";
import request from "@/utils/request";
import { getExpandCustomerID } from "@/utils";
export interface LoginRequest {
  mobile: string;
  code: string;
  expand_customer_id?: string;
}

type TokenInfo = {
  is_first_login: "Y" | "N";
} | null;

interface LoginResponse {
  token: string;
  timeout: string;
  token_info: TokenInfo;
}

/**
 * 用户手机登录接口
 */
export function login(data: LoginRequest): LoginResponse {
  data.expand_customer_id = getExpandCustomerID();
  return request({
    url: "v1/user/auth/login",
    method: "post",
    data
  });
}

interface GetCodeRequest {
  mobile: string;
  timestamp: number;
  sign: string;
}

/**
 * 获取手机验证码
 */
export function getCode(mobile: string) {
  const timestamp = Math.round(+new Date() / 1000);
  const params: GetCodeRequest = {
    mobile,
    timestamp,
    sign: md5(mobile + "ee7aebd9fd5047b4a35655c93561c6c04" + timestamp)
  };

  return request({
    url: "v1/user/auth/get_code",
    method: "get",
    params
  });
}

//获取个人信息
export function getInfo(is_all: number) {
  return request({
    url: "v1/user/info/get",
    method: "get",
    params: {
      is_all // 0基础信息1包含省市县
    }
  });
}
